import PropTypes from 'prop-types';

export const propTypes = {
  classNames: PropTypes.string,
  children: PropTypes.node,
};

export const defaultProps = {};
